import './PopupPetLocationInput.scss';

import LocationInput from 'components/LocationInput/LocationInput';
import { observer } from 'mobx-react-lite';
import { useTemplatedText } from 'petdna-lib-uicomponents/hooks';
import React, {
  FC, useCallback, useId, useMemo, useState,
} from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import {
  IPopup,
  IPopupSimpleContent,
  TPopupSetting,
} from 'stores/types/Popups';
import { PetLocation } from 'stores/types/Profiles';
import { useStores } from 'stores/useStores';

interface IPopupPetLocationInputProps {
  formId: string;
  popup: IPopup<TPopupSetting, IPopupSimpleContent>;
  onClose: () => void;
}

const PopupPetLocationInput: FC<IPopupPetLocationInputProps> = observer(({
  formId,
  popup,
  onClose,
}) => {
  const { t } = useTranslation();
  const unknownInputId = useId();
  const [location, setLocation] = useState<PetLocation>();
  const { testsStore } = useStores();

  const placeholder = useTemplatedText(popup.content.inputPlaceholder);

  const handleFormSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      if (!testsStore.petProfile?.testGUID || !location?.locationId) return;
      await testsStore.updatePetProfiles(testsStore.petProfile.testGUID, {
        location,
      });
      onClose();
    } catch (error) {
      console.error(error);
      const msg = (error as any).message ?? t('somethingWentWrong');
      toast.error(msg);
    }
  }, [location, testsStore, onClose, t]);

  return (
    <form id={formId} onSubmit={handleFormSubmit} className="popup-location-input">
      <label
        htmlFor={unknownInputId}
        className="popup-location-input__label"
      >
        {popup.content.inputLabel}
      </label>
      <LocationInput
        id={unknownInputId}
        value={location}
        onChange={setLocation}
        className="popup-location-input__input"
        placeholder={placeholder}
      />
    </form>
  );
});

export default PopupPetLocationInput;
